/* Cudeman · Selector de cuchillos · interfaz.
   Dos paginas: /pages/que-cuchillo-elegir (preguntas) y /pages/tu-cuchillo-ideal (resultados; las respuestas van en la URL).
   Datos: templates/collection.kf-data.liquid (siempre en espanol para la logica + idioma del visitante para mostrar). */
(function () {
  'use strict';
  var root = document.getElementById('kf-app');
  if (!root || !window.KFEngine) return;
  var E = window.KFEngine, I = window.KFIcons || {};
  var CFG = window.KF_CONFIG || {};
  var LANG = CFG.lang === 'en' ? 'en' : 'es';
  var T = window.KF_I18N[LANG], GL = window.KF_GLOSS, STEEL = window.KF_STEEL[LANG], EXG = window.KF_EXTRA;
  var DATA = [];

  // ---------------------------------------------------------------- utilidades
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function ic(n, cls) { return '<svg class="kf-ic ' + (cls || '') + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (I[n] || '') + '</svg>'; }
  function fmt(s, o) { return String(s).replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); }
  function low(s) { return (s || '').charAt(0).toLowerCase() + (s || '').slice(1); }
  function cap(s) { return (s || '').charAt(0).toUpperCase() + (s || '').slice(1); }
  function num(v, u) { return v == null ? '—' : String(v).replace('.', T.dec) + (u ? ' ' + u : ''); }
  function img(u, w) { return u ? u + (u.indexOf('?') > 0 ? '&' : '?') + 'width=' + w : ''; }
  // dinero con el formato de la tienda (p.ej. "€{{amount_with_comma_separator}}")
  function money(cents, noDec) {
    var f = CFG.moneyFormat || '€{{amount_with_comma_separator}}', v = (cents / 100);
    function d(n, dec, th, ds) { var s = n.toFixed(dec).split('.'); s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return s.join(ds); }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals' || noDec && k === 'amount') return d(v, 0, ',', '.');
      if (k === 'amount_no_decimals_with_comma_separator' || noDec) return d(v, 0, '.', ',');
      if (k === 'amount_with_comma_separator') return d(v, 2, '.', ',');
      return d(v, 2, ',', '.');
    });
  }
  function eur(p) { return money(Math.round(p * 100)); }
  // texto a mostrar: en ingles viene de las traducciones de la tienda; si falta, el original
  function D(p, k) { return (p.L && p.L[k]) || p[k]; }
  function gloss(v) { for (var i = 0; i < GL.length; i++) if (GL[i][0].test(v || '')) return GL[i][LANG === 'en' ? 2 : 1]; return ''; }
  function name(p) { return D(p, 't').replace(/^Cudeman\s+/i, ''); }
  function link(p) { return D(p, 'url') || ('/products/' + p.h); }
  var KEYS = { col: 'c', quien: 'q', uso: 'u', tipo: 't', tam: 's', prio: 'p', foco: 'f', det: 'd', pres: 'b' };
  var CT = (window.KF_CAT || {})[LANG] || {};
  // pregunta a mostrar: la propia de la categoria (foco) o la general
  function qdef(key) { if (key === 'foco') { var c = E.catOf(A); return CT.foco && CT.foco[c]; } return T.q[key]; }
  function colCount() { return DATA.filter(function (p) { return p.stock > 0 && (p.cols || []).indexOf(A.col) >= 0; }).length; }
  var PRICE = { m50: money(5000, true), m80: money(8000, true), m120: money(12000, true) };
  function optLabel(o) { return o[0] === 'nuevo' && A && A.col && A.tipo === 'N' && CT.firstN ? CT.firstN : fmt(o[2], PRICE); }

  function encode(a) {
    return Object.keys(KEYS).filter(function (k) { return a[k] !== undefined && !(k === 'det' && !(a.det || []).length); })
      .map(function (k) { return KEYS[k] + '=' + encodeURIComponent(k === 'det' ? a.det.join(',') : a[k]); }).join('&');
  }
  function decode(qs) {
    var a = {}, p = new URLSearchParams(qs);
    Object.keys(KEYS).forEach(function (k) { var v = p.get(KEYS[k]); if (v !== null && v !== '') a[k] = k === 'det' ? v.split(',').filter(function (x) { return E.DET[x]; }) : v; });
    if (!a.det) a.det = [];
    E.applyCol(a);
    return { a: a, paso: p.get('paso') };
  }
  function go(view, a, paso) {
    var qs = encode(a) + (paso ? (encode(a) ? '&' : '') + 'paso=' + paso : '');
    location.href = (view === 'results' ? CFG.resultsUrl : CFG.quizUrl) + (qs ? '?' + qs : '');
  }

  // ---------------------------------------------------------------- preguntas
  var A = { det: [] }, idx = 0, editing = false;

  function optionsFor(key) {
    var q = qdef(key); if (!q) return [];
    return q.o.filter(function (o) {
      if (key === 'prio' && o[4] === 'exp' && A.quien !== 'exp') return false;
      if (key === 'quien' || o[0] === 'igual' || o[0] === 'nose' || (key === 'uso' && !A.col)) return true;
      return E.available(DATA, A, key, o[0]);              // sin piezas = no se muestra
    });
  }

  function heroHTML(compact) {
    var title = A.col && CT.single ? fmt(CT.hero, { cat: CT.single[A.col] }) : T.heroTitle;
    var sub = A.col && CT.names ? fmt(CT.heroSub, { n: colCount(), cats: CT.names[A.col] }) + ' <button type="button" class="kf-link kf-link--inline" data-act="allcats">' + CT.allCats + '</button>' : T.heroSub;
    return '<section class="kf-hero' + (compact ? ' kf-hero--compact' : '') + '"><div class="kf-wrap"><p class="kf-over">' + T.over + '</p><h1 class="kf-h1">' + title + '</h1>' +
      (compact ? '' : '<p class="kf-hero__sub">' + sub + '</p><ul class="kf-hero__pts">' + T.heroPts.map(function (x) { return '<li>' + ic(x[0]) + shipTxt(x) + '</li>'; }).join('') + '</ul>') +
      '</div></section>';
  }

  function renderQuiz() {
    var st = E.steps(A);
    if (idx >= st.length) return go('results', A);
    var key = st[idx], q = qdef(key), gift = A.quien === 'regalo', opts = optionsFor(key);
    // si una pregunta solo deja una opcion real, no aporta: se salta
    if ((key === 'tipo' || key === 'tam' || key === 'foco') && opts.filter(function (o) { return o[0] !== 'igual'; }).length <= 1) { A[key] = 'igual'; idx++; return renderQuiz(); }
    var bt = E.bucketType(A), h = heroHTML(idx > 0) + '<section class="kf-quiz"><div class="kf-wrap kf-wrap--narrow">' +
      '<div class="kf-bar"><button type="button" class="kf-back"' + (idx === 0 ? ' hidden' : '') + ' data-act="back">' + ic('chevron-left') + T.back + '</button>' +
      '<span class="kf-stepn">' + fmt(T.step, { n: idx + 1, t: st.length }) + '</span></div>' +
      '<div class="kf-prog" role="progressbar" aria-valuemin="0" aria-valuemax="' + st.length + '" aria-valuenow="' + idx + '"><i style="width:' + Math.round(100 * idx / st.length) + '%"></i></div>' +
      '<h2 class="kf-h2" id="kf-q" tabindex="-1">' + (gift && q.tg ? q.tg : q.t) + '</h2><p class="kf-sub">' + (gift && q.sg ? q.sg : q.s) + '</p>';
    if (key === 'tam') h += ruler(bt);
    if (key === 'det') {
      h += '<div class="kf-chips" role="group">' + opts.map(function (o) {
        var on = A.det.indexOf(o[0]) >= 0;
        return '<button type="button" class="kf-chip' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-det="' + o[0] + '">' + ic(on ? 'check' : 'plus', 'kf-chip__i') + o[1] + '</button>';
      }).join('') + '</div><div class="kf-actions"><button type="button" class="kf-btn kf-btn--dark" data-act="next">' + (A.det.length ? T.next : T.skipDet) + ic('arrow-right') + '</button></div>';
    } else {
      h += '<div class="kf-opts">' + opts.map(function (o) {
        var desc = o[3];
        if (key === 'tam' && o[0] !== 'igual') desc = o[3] + ' · ' + T.sizeRange[bt]['sml'.indexOf(o[0])];
        var alt = o[0] === 'igual' || o[0] === 'nose';
        return '<button type="button" class="kf-opt' + (alt ? ' kf-opt--alt' : '') + (A[key] === o[0] ? ' is-on' : '') + '" aria-pressed="' + (A[key] === o[0]) + '" data-k="' + key + '" data-v="' + o[0] + '">' +
          '<span class="kf-opt__ic">' + ic(o[1]) + '</span><span class="kf-opt__tx"><b>' + optLabel(o) + '</b>' + (desc ? '<span>' + desc + '</span>' : '') + '</span>' +
          '<span class="kf-opt__ok">' + ic('check') + '</span></button>';
      }).join('') + '</div>';
    }
    if (q.help) h += '<details class="kf-help"><summary>' + ic('info') + q.help[0] + '</summary><div>' + q.help[1] + '</div></details>';
    h += '</div></section>';
    root.innerHTML = h;
    focusTop(idx > 0);
  }

  function ruler(bt) {
    var b = E.BUCKETS[bt], max = bt === 'N' ? 11 : (bt === 'F' ? 20 : 16), o = T.q.tam.o, r = T.sizeRange[bt];
    var rows = [['card', T.card, 8.5], ['b1', o[0][2] + ' · ' + r[0], b[0]], ['b2', o[1][2] + ' · ' + r[1], b[1]], ['b3', o[2][2] + ' · ' + r[2], max]];
    return '<div class="kf-ruler" role="img" aria-label="' + esc(rows.map(function (x) { return x[1]; }).join('. ')) + '">' + rows.map(function (x) {
      return '<div class="kf-ruler__r"><span>' + x[1] + '</span><i class="kf-ruler__' + x[0] + '" style="width:' + (100 * x[2] / max).toFixed(1) + '%"></i></div>'; }).join('') + '</div>';
  }

  // borra respuestas posteriores que ya no aplican tras cambiar una anterior
  function prune(fromKey) {
    var st = E.steps(A);
    Object.keys(KEYS).forEach(function (k) { if (k !== 'det' && k !== 'col' && !(A.col && (k === 'uso' || k === 'tipo')) && st.indexOf(k) < 0) delete A[k]; });
    if (st.indexOf('det') < 0) A.det = [];
    var part = { det: [] }, i = st.indexOf(fromKey) + 1;
    st.slice(0, i).forEach(function (k) { part[k] = A[k]; });
    for (; i < st.length; i++) {
      var k = st[i];
      if (k === 'det') { A.det = A.det.filter(function (d) { return E.available(DATA, part, 'det', d); }); part.det = A.det.slice(); continue; }
      if (A[k] === undefined) break;
      if (A[k] !== 'igual' && !E.available(DATA, part, k, A[k])) { for (var j = i; j < st.length; j++) if (st[j] !== 'det') delete A[st[j]]; break; }
      part[k] = A[k];
    }
  }

  function pick(k, v, btn) {
    A[k] = v; prune(k);
    Array.prototype.forEach.call(root.querySelectorAll('.kf-opt'), function (b) { b.classList.toggle('is-on', b === btn); b.setAttribute('aria-pressed', b === btn); });
    var st = E.steps(A), nxt = st.indexOf(k) + 1;
    if (editing && st.slice(nxt).every(function (n) { return n === 'det' || A[n] !== undefined; })) nxt = st.length;
    setTimeout(function () { idx = nxt; renderQuiz(); }, 220);
  }

  // ---------------------------------------------------------------- resultados
  function mat(p) {
    var m = D(p, 'mangoTxt') || '';
    m = LANG === 'en' ? m.replace(/^(satin|polished)\s+/i, '').replace(/\s+with\s+.*$/i, '')
      : m.replace(/\s+(satinad[oa]|pulid[oa])\b.*$/i, '').replace(/\s+con separador.*$/i, '');
    return LANG === 'en' ? m.replace(/^\w/, function (c) { return c.toLowerCase(); }).replace(/\bmicarta\b/i, 'Micarta') : low(m);
  }
  function fundaTxt(p) {
    var f = D(p, 'fundaTxt') || '';
    f = f.replace(/\s*\((included|optional|incluida|opcional)\)/ig, '').replace(/\s*\(Ref\.[^)]*\)/i, '').trim();
    return LANG === 'en' ? f.replace(/\bsheath\b/i, '').trim().toLowerCase() : f.toLowerCase();
  }
  function grip(p) { return /micarta|g-?10|caucho|canvas|yute/i.test(p.mangoTxt); }
  function extraHit(p, re) { for (var i = 0; i < p.extras.length; i++) if (re.test(p.extras[i])) return extraName(p, i); return ''; }
  function extraName(p, i) {
    var e = (p.L && p.L.extras && p.L.extras[i]) || p.extras[i];
    if (LANG === 'en' && e === p.extras[i]) for (var j = 0; j < EXG.length; j++) if (EXG[j][0].test(e) && EXG[j][3]) return EXG[j][3];
    return e.replace(/:$/, '');
  }

  function reasons(p, max) {
    var R = T.R, r = [], hrc = p.hrc && p.hrc.length ? ' (' + p.hrc.join('/') + ' HRC)' : '';
    var steel = p.acero === 'boh' || p.acero === 'san' ? fmt(R.steelHard, { a: D(p, 'aceroTxt').replace(/\s*steel$/i, ''), h: hrc })
      : p.acero === 'mova' ? R.steelMova : p.acero === '420' ? R.steel420 : '';
    var m = mat(p), M = cap(m), g = p.grosor ? num(p.grosor, 'mm') : '';
    var byPrio = {
      filo: steel, afilar: p.acero === 'mova' ? R.sharpen : steel,
      mant: p.mango === 'syn' ? fmt(R.care, { m: m }) : steel,
      agarre: grip(p) ? fmt(R.grip, { m: m, M: M }) : '',
      madera: p.mango === 'nat' ? fmt(R.wood, { m: m, M: M, nat: /natural/i.test(m) ? '' : R.natWord }) : '',
      ligero: p.peso ? fmt(R.light, { w: num(p.peso, 'g') }) : '',
      robusto: g ? fmt(R.tough, { g: g, e: p.tipo === 'F' && p.ent ? R.fullTang : '' }) : ''
    };
    var fuego = extraHit(p, /fuego|pedernal|chispa/i), perc = extraHit(p, /percutor|rompe/i);
    var byUse = {
      caza: /desollador/i.test(p.punta) ? R.skinner : (/drop/i.test(p.punta) ? R.drop : ''),
      bush: /escandinav/i.test(p.afilado) ? R.scandi : (fuego ? fmt(R.includes, { x: low(fuego) }) : ''),
      superv: perc ? fmt(R.includes, { x: low(perc) }) : (p.grosor >= 4.5 ? fmt(R.thick, { g: g }) : ''),
      diario: p.cierre ? fmt(R.lock, { c: low(D(p, 'cierre')) }) : '',
      colec: /lima y buril/i.test(p.extras.join(' ')) ? R.filework : (p.mango === 'nat' ? fmt(R.unique, { m: m, M: M }) : '')
    };
    var sz = E.sizeOf(p, p.tipo), fd = fundaTxt(p);
    // la pregunta propia de la categoria tambien da su motivo
    var FP = { ligera: 'ligero', robusta: 'robusto', tradicional: 'madera', agarre: 'agarre', resistente: 'robusto', lena: 'robusto', nobles: 'madera' };
    var pg = (gloss(p.punta) || '').replace(/\.$/, ''), byFoco = {
      remate: pg, bowie: pg, monteria: pg, tallar: /escandinav/i.test(p.afilado) ? R.scandi : (gloss(p.afilado) || '').replace(/\.$/, ''),
      fuego: fuego ? fmt(R.includes, { x: low(fuego) }) : '', emergencia: perc ? fmt(R.includes, { x: low(perc) }) : '',
      oscuro: (gloss(p.acabado) || '').replace(/\.$/, ''), moderno: grip(p) ? fmt(R.grip, { m: m, M: M }) : ''
    };
    [byFoco[A.foco], byPrio[A.prio || FP[A.foco]], byUse[A.uso],
     A.quien === 'nuevo' && p.tipo === 'N' && p.cierre ? R.firstLock : '',
     p.hoja ? fmt(R.blade, { cm: num(p.hoja, 'cm'), s: T.sizes['sml'.indexOf(sz)] }) : '',
     p.tipo === 'N' && p.cierre ? fmt(R.lock, { c: low(D(p, 'cierre')) }) : '',
     steel, p.funda && fd ? fmt(R.sheath, { f: fd, F: cap(fd) }) : '',
     p.rank < 12 ? R.bestseller : ''
    ].forEach(function (x) { if (x && r.indexOf(x) < 0 && r.length < max) r.push(x); });
    return r;
  }

  function devTxt(x) {
    if (!x.dev.length) return '';
    var p = x.p, d = [];
    if (x.dev.indexOf('tam') >= 0) d.push('sml'.indexOf(E.sizeOf(p, E.bucketType(A))) > 'sml'.indexOf(A.tam) ? T.dev.bigger : T.dev.smaller);
    if (x.dev.indexOf('pres') >= 0) d.push(p.p >= E.PRES[A.pres][1] ? fmt(T.dev.over, { x: eur(p.p - E.PRES[A.pres][1]) }) : T.dev.under);
    if (x.dev.indexOf('tipo') >= 0) d.push(p.tipo === 'N' ? T.dev.navaja : T.dev.fijo);
    if (x.dev.indexOf('det') >= 0) d.push(T.dev.det);
    if (x.dev.indexOf('foco') >= 0) d.push(T.dev.foco);
    return '<p class="kf-dev">' + ic('info') + '<span>' + T.near + d.join(T.and) + '.</span></p>';
  }

  function segs(v) { var s = ''; for (var i = 1; i <= 5; i++) s += '<i class="' + (v >= i ? 'on' : (v >= i - 0.5 ? 'half' : '')) + '"></i>'; return '<span class="kf-prof__b" role="img" aria-label="' + v + '/5">' + s + '</span>'; }
  function bars(p) {
    var f = E.perfil(p), order = A.prio === 'afilar' ? ['filo', 'afilado', 'resistencia', 'ligereza', 'cuidado'] : ['filo', 'cuidado', 'resistencia', 'ligereza', 'afilado'];
    return '<div class="kf-prof">' + order.map(function (k) { return '<div class="kf-prof__r"><span>' + T.prof[k] + '</span>' + segs(f[k]) + '</div>'; }).join('') +
      '<p class="kf-prof__n">' + T.howNote + '</p></div>';
  }

  // misma rejilla de especificaciones que la ficha de producto (specs-highlights)
  function specGrid(p) {
    var items = [['wrench', T.rows.acero, D(p, 'aceroTxt')], ['shield', T.rows.dureza, p.hrc.length ? p.hrc.join('/') + ' HRc' : ''], ['ruler', T.rows.hoja, p.hoja ? num(p.hoja, 'cm') : ''],
      ['maximize-2', T.rows.total, p.total ? num(p.total, 'cm') : ''], ['feather', T.rows.peso, p.peso ? num(p.peso, 'g') : ''], ['trees', T.rows.mango, D(p, 'mangoTxt')]];
    return '<div class="specs-highlights kf-specs">' + items.filter(function (x) { return x[2]; }).map(function (x) {
      return '<div class="specs-highlights__item">' + ic(x[0], 'specs-highlights__icon') + '<div class="specs-highlights__text"><span class="specs-highlights__label">' + x[1] + '</span><span class="specs-highlights__value">' + esc(x[2]) + '</span></div></div>';
    }).join('') + '</div>';
  }

  function fullSpecs(p) {
    var fd = D(p, 'fundaTxt');
    var rows = [[T.rows.ref, p.ref], [T.rows.tipo, p.tipo === 'N' ? T.navaja : T.fijo], [T.rows.hoja, p.hoja && num(p.hoja, 'cm')], [T.rows.total, p.total && num(p.total, 'cm')],
      [T.rows.grosor, p.grosor && num(p.grosor, 'mm')], [T.rows.ancho, p.ancho && num(p.ancho, 'cm')], [T.rows.peso, p.peso && num(p.peso, 'g')],
      [T.rows.acero, D(p, 'aceroTxt'), STEEL[p.acero]], [T.rows.dureza, p.hrc.length ? p.hrc.join('/') + ' HRC' : '', p.hrc.length ? T.hrcNote : ''],
      [T.rows.afilado, D(p, 'afilado'), gloss(p.afilado)], [T.rows.acabado, D(p, 'acabado'), gloss(p.acabado)], [T.rows.punta, D(p, 'punta'), gloss(p.punta)],
      [T.rows.cierre, p.cierre ? D(p, 'cierre') : '', gloss(p.cierre)], [T.rows.estructura, D(p, 'estructura'), gloss(p.estructura)], [T.rows.virola, p.virola ? D(p, 'virola') : ''],
      [T.rows.anclaje, D(p, 'anclaje')], [T.rows.mango, D(p, 'mangoTxt'), gloss(p.mangoTxt)],
      [T.rows.funda, fd ? fd.replace(/\s*\((included|optional|incluida|opcional)\)/ig, '') + (p.funda ? ' (' + T.incl + ')' : p.fundaOpc ? ' (' + T.opc + ')' : '') : '', gloss(p.fundaTxt)]];
    var h = '<dl class="kf-full">' + rows.filter(function (r) { return r[1]; }).map(function (r) {
      return '<div><dt>' + r[0] + '</dt><dd>' + esc(r[1]) + (r[2] ? '<small>' + r[2] + '</small>' : '') + '</dd></div>';
    }).join('');
    if (p.extras.length) h += '<div><dt>' + T.rows.extras + '</dt><dd><ul>' + p.extras.map(function (e, i) {
      var g = ''; for (var j = 0; j < EXG.length; j++) if (EXG[j][0].test(e)) { g = EXG[j][LANG === 'en' ? 2 : 1]; break; }
      return '<li>' + esc(extraName(p, i)) + (g ? '<small>' + g + '</small>' : '') + '</li>'; }).join('') + '</ul></dd></div>';
    return h + '</dl>';
  }

  function stock(p) { return '<p class="kf-stock"><i></i>' + (p.tracked && p.qty > 0 && p.qty <= 5 ? fmt(T.lowStock, { n: p.qty }) : T.inStock) + '</p>'; }
  function stars(p) { return p.rc && p.r ? '<p class="kf-stars">' + ic('star', 'kf-star') + String(p.r).replace('.', T.dec) + ' · ' + p.rc + ' ' + (p.rc === 1 ? T.review : T.reviews) + '</p>' : ''; }
  function price(p) { return (p.pmax > p.p ? T.from : '') + eur(p.p); }
  function prodA(p, cls, inner) { return '<a class="' + cls + '" href="' + esc(link(p)) + '" data-kf-prod="' + esc(p.h) + '">' + inner + '</a>'; }

  function summary() {
    var pills = E.steps(A).map(function (k) {
      var val = k === 'det' ? A.det.map(function (d) { return T.q.det.o.filter(function (o) { return o[0] === d; })[0][1]; }).join(', ')
        : optLabel((qdef(k) || { o: [] }).o.filter(function (o) { return o[0] === A[k]; })[0] || ['', '', '']);
      return val ? '<button type="button" class="kf-pill" data-edit="' + k + '">' + esc(val) + ic('pencil') + '</button>' : '';
    }).join('');
    var cat = A.col && CT.names ? '<button type="button" class="kf-pill kf-pill--cat" data-act="allcats" title="' + esc(CT.allCats) + '">' + esc(cap(CT.names[A.col])) + ic('x') + '</button>' : '';
    return cat + pills;
  }

  function gallery(p) {
    return '<div class="kf-gal"><div class="kf-gal__main">' + prodA(p, 'kf-gal__a', '<img src="' + esc(img(p.imgs[0], 1000)) + '" alt="' + esc(D(p, 't')) + '" width="1000" height="1000" data-main>') + '</div>' +
      (p.imgs.length > 1 ? '<div class="kf-gal__th">' + p.imgs.map(function (u, i) {
        return '<button type="button" class="' + (i === 0 ? 'is-on' : '') + '" data-img="' + esc(img(u, 1000)) + '" aria-label="' + T.photo + ' ' + (i + 1) + '"><img src="' + esc(img(u, 180)) + '" alt="" loading="lazy" width="90" height="90"></button>'; }).join('') + '</div>' : '') + '</div>';
  }

  function gridCard(p) {   // misma tarjeta que las colecciones
    return '<div class="kf-card">' + prodA(p, 'kf-card__img', '<img src="' + esc(img(p.imgs[0], 540)) + '" alt="' + esc(D(p, 't')) + '" loading="lazy" width="540" height="540">' +
      (p.imgs[1] ? '<img class="kf-card__hover" src="' + esc(img(p.imgs[1], 540)) + '" alt="" loading="lazy" width="540" height="540">' : '')) +
      prodA(p, 'kf-card__t', esc(D(p, 't'))) + '<div class="kf-card__ref">Ref:' + esc(p.ref) + '</div><div class="kf-card__p">' + price(p) + '</div></div>';
  }

  function compareTable(top) {
    var ps = top.map(function (x) { return x.p; }), f = ps.map(E.perfil);
    var rows = [[T.rows.precio, ps.map(price)], [T.rows.tipo, ps.map(function (p) { return p.tipo === 'N' ? T.navaja : T.fijo; })],
      [T.rows.hoja, ps.map(function (p) { return num(p.hoja, 'cm'); })], [T.rows.peso, ps.map(function (p) { return num(p.peso, 'g'); })],
      [T.prof.filo, f.map(function (x) { return segs(x.filo); })], [T.prof.cuidado, f.map(function (x) { return segs(x.cuidado); })],
      [T.prof.resistencia, f.map(function (x) { return segs(x.resistencia); })], [T.prof.ligereza, f.map(function (x) { return segs(x.ligereza); })],
      [T.rows.acero, ps.map(function (p) { return esc(D(p, 'aceroTxt')); })], [T.rows.mango, ps.map(function (p) { return esc(D(p, 'mangoTxt')); })],
      [T.rows.punta, ps.map(function (p) { return esc(D(p, 'punta') || '—'); })],
      [T.rows.cierreEst, ps.map(function (p) { return esc(p.tipo === 'N' ? (p.cierre ? D(p, 'cierre') : '—') : (D(p, 'estructura') || '—')); })],
      [T.rows.funda, ps.map(function (p) { return p.funda ? T.inclCap : (p.fundaOpc ? T.opcCap : '—'); })]];
    return '<div class="kf-cmp" tabindex="0"><table><thead><tr><th></th>' + ps.map(function (p) {
      return '<th>' + prodA(p, '', '<img src="' + esc(img(p.imgs[0], 220)) + '" alt="" width="100" height="100" loading="lazy"><span>' + esc(name(p)) + '</span>') + '</th>'; }).join('') +
      '</tr></thead><tbody>' + rows.map(function (r) { return '<tr><th scope="row">' + r[0] + '</th>' + r[1].map(function (c) { return '<td>' + c + '</td>'; }).join('') + '</tr>'; }).join('') + '</tbody></table></div>';
  }

  var shown = 0, restList = [];
  function renderResults() {
    var r = E.recommend(DATA, A), gift = A.quien === 'regalo', top = r.top;
    if (!top.length) return go('quiz', { det: [] });
    var x0 = top[0], p = x0.p;
    var cheapest = Math.min.apply(null, top.map(function (x) { return x.p.p; })), bestRank = Math.min.apply(null, top.map(function (x) { return x.p.rank; }));
    function tag(x) {
      var q = x.p;
      if (q.rank === bestRank && q.rank < 25 && q.rank < p.rank) return T.tags.best;
      if (q.p === cheapest && q.p < p.p * 0.9) return T.tags.cheap;
      if (q.hoja && p.hoja && q.hoja <= p.hoja - 2) return T.tags.small;
      if (A.uso !== 'lanz' && q.peso && p.peso && q.peso <= p.peso * 0.8) return T.tags.light;
      if (q.hoja && p.hoja && q.hoja >= p.hoja + 2) return T.tags.big;
      return T.tags.alt;
    }
    var why = function (q, n, cls) { return '<ul class="kf-why' + (cls || '') + '">' + reasons(q, n).map(function (t) { return '<li>' + ic('check') + '<span>' + t + '</span></li>'; }).join('') + '</ul>'; };
    var h = '<section class="kf-rhead"><div class="kf-wrap"><p class="kf-over">' + T.rOver + (A.col && CT.names ? ' · ' + CT.names[A.col] : '') + '</p><h1 class="kf-h1">' + (gift ? T.rTitleG : T.rTitle) + '</h1>' +
      '<div class="kf-pills">' + summary() + '</div><div class="kf-rhead__act"><button type="button" class="kf-link" data-act="share">' + ic('share-2') + '<span>' + T.share + '</span></button>' +
      '<button type="button" class="kf-link" data-act="restart">' + ic('rotate-ccw') + T.restart + '</button></div></div></section>';

    h += '<section class="kf-main"><div class="kf-wrap kf-main__grid">' + gallery(p) + '<div class="kf-main__info">' +
      '<span class="kf-badge">' + (x0.dev.length ? T.bestNear : T.best) + '</span><h2 class="kf-ptitle">' + prodA(p, '', esc(D(p, 't'))) + '</h2><p class="kf-ref">' + esc(p.ref) + '</p>' +
      '<p class="kf-price">' + price(p) + '</p>' + stock(p) + stars(p) + devTxt(x0) +
      '<h3 class="kf-h3">' + T.why + '</h3>' + why(p, 4) + '<h3 class="kf-h3">' + T.how + '</h3>' + bars(p) + specGrid(p) +
      '<details class="kf-more"><summary>' + ic('info') + T.specs + '</summary>' + fullSpecs(p) + '</details>' +
      prodA(p, 'kf-btn kf-btn--dark kf-btn--full', T.see + ' · ' + price(p)) +
      '<div class="trust-badges kf-trust">' + T.trust.map(function (t) { return '<div class="trust-badges__item">' + ic(t[0], 'trust-badges__icon') + '<span class="trust-badges__label">' + shipTxt(t) + '</span></div>'; }).join('') + '</div>' +
      '</div></div></section>';

    if (top.length > 1) {
      h += '<section class="kf-sec"><div class="kf-wrap"><h2 class="kf-h2">' + T.others + '</h2><div class="kf-alts">' + top.slice(1).map(function (x) {
        var q = x.p;
        return '<article class="kf-alt">' + prodA(q, 'kf-alt__img', '<img src="' + esc(img(q.imgs[0], 600)) + '" alt="' + esc(D(q, 't')) + '" loading="lazy" width="600" height="600">') +
          '<div class="kf-alt__b"><span class="kf-badge kf-badge--soft">' + tag(x) + '</span><h3 class="kf-alt__t">' + prodA(q, '', esc(D(q, 't'))) + '</h3><p class="kf-price">' + price(q) + '</p>' + devTxt(x) +
          why(q, 3, ' kf-why--sm') + stars(q) + prodA(q, 'kf-btn kf-btn--ghost', T.see) + '</div></article>';
      }).join('') + '</div></div></section>';
      h += '<section class="kf-sec"><div class="kf-wrap"><h2 class="kf-h2">' + T.compare + '</h2>' + compareTable(top) + '</div></section>';
    }
    restList = r.rest.map(function (x) { return x.p; });
    if (restList.length) h += '<section class="kf-sec"><div class="kf-wrap"><h2 class="kf-h2">' + T.more + '</h2><div class="kf-grid" id="kf-grid"></div>' +
      '<div class="kf-actions kf-actions--c"><button type="button" class="kf-btn kf-btn--ghost" data-act="more" id="kf-morebtn">' + T.moreBtn + '</button></div></div></section>';
    h += '<section class="kf-sec kf-sec--end"><div class="kf-wrap"><p class="kf-helpline">' + ic('message-circle') + T.help + '</p>' +
      (top.some(function (x) { return x.p.tipo === 'N'; }) || A.uso === 'diario' ? '<p class="kf-legal">' + T.legal + '</p>' : '') + '</div></section>';
    root.innerHTML = h;
    shown = 0; moreCards();
    focusTop(false);
    lastTop = top.map(function (x) { return x.p.h; });
    // recuerda la recomendacion para el hero de la home (solo en este navegador; respeta el aviso de cookies)
    try {
      var cp = window.Shopify && Shopify.customerPrivacy, okPrefs = !(cp && cp.preferencesProcessingAllowed) || cp.preferencesProcessingAllowed();
      if (okPrefs) localStorage.setItem('kf_last', JSON.stringify({ h: p.h, u: location.pathname + location.search, t: Date.now() }));
    } catch (e) {}
    track('kf_results', answersData({ recomendada: lastTop[0] || '', alternativas: lastTop.slice(1).join(','), encajan: r.exact }));
  }
  function moreCards() {
    var g = document.getElementById('kf-grid'); if (!g) return;
    var next = restList.slice(shown, shown + 8); shown += next.length;
    g.insertAdjacentHTML('beforeend', next.map(gridCard).join(''));
    var b = document.getElementById('kf-morebtn'); if (b) b.hidden = shown >= restList.length;
  }

  function focusTop(toQuestion) {
    var y = root.getBoundingClientRect().top + window.pageYOffset - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-sticky-height'), 10) || 60);
    if (window.pageYOffset > y + 5) window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    var el = toQuestion ? document.getElementById('kf-q') : null;
    if (el) el.focus({ preventScroll: true });
  }

  // envio 24/48 h solo en Espana: se pintan los dos textos y la clase kf-intl de <html> decide (snippet kf-envio-pais)
  function shipTxt(x) { return x[2] ? '<span class="kf-es-txt">' + x[1] + '</span><span class="kf-intl-txt">' + x[2] + '</span>' : x[1]; }
  // medicion: evento para analitica (si existe) + marca en el carrito para saber que pedidos vienen del selector
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
  }
  // respuestas en espanol legible (para leer los pedidos aunque el cliente compre en ingles)
  function readable() {
    var es = window.KF_I18N.es;
    var parts = E.steps(A).map(function (k) {
      if (k === 'det') return A.det.map(function (d) { return es.q.det.o.filter(function (o) { return o[0] === d; })[0][1]; }).join(', ');
      var src = k === 'foco' ? (((window.KF_CAT || {}).es || {}).foco || {})[E.catOf(A)] : es.q[k];
      var o = src && src.o.filter(function (x) { return x[0] === A[k]; })[0];
      return o ? fmt(o[2], PRICE) : '';
    }).filter(Boolean);
    if (A.col) parts.unshift(cap((((window.KF_CAT || {}).es || {}).names || {})[A.col] || A.col));
    return parts.join(' | ');
  }
  function answersData(extra) {
    return Object.assign({ respuestas: readable(), codigo: encode(A), quien: A.quien || '', uso: A.uso || '', tipo: A.tipo || '', tamano: A.tam || '',
      prioridad: A.prio || '', presupuesto: A.pres || '', categoria: A.col || '', foco: A.foco || '', detalles: (A.det || []).join(','), idioma: LANG }, extra || {});
  }
  var lastTop = [];
  // al entrar en una pieza: se apunta en el carrito (atributos ocultos que pasan al pedido) para saber que pedidos vienen del selector y con que respuestas
  function markCart(handle, el) {
    var pos = lastTop.indexOf(handle) + 1;
    var zona = el.closest('.kf-cmp') ? 'comparador' : el.closest('.kf-card') ? 'mas-piezas' : el.closest('.kf-alt') ? 'alternativa' : 'principal';
    var d = answersData({ pieza: handle, posicion: pos ? String(pos) : 'mas', zona: zona });
    track('kf_click', d);
    if (!CFG.trackCart) return;
    try {
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', keepalive: true,
        body: JSON.stringify({ attributes: { _selector: 'si', _selector_respuestas: d.respuestas, _selector_codigo: d.codigo, _selector_pieza: handle,
          _selector_posicion: d.posicion + ' (' + zona + ')', _selector_idioma: LANG } }) });
    } catch (e) {}
  }

  // ---------------------------------------------------------------- eventos
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button, a'); if (!b || !root.contains(b)) return;
    if (b.dataset.kfProd) return markCart(b.dataset.kfProd, b);
    if (b.dataset.k) return pick(b.dataset.k, b.dataset.v, b);
    if (b.dataset.det) {
      var d = b.dataset.det, i = A.det.indexOf(d);
      if (i >= 0) A.det.splice(i, 1); else A.det.push(d);
      return renderQuiz();
    }
    if (b.dataset.img) {
      var m = root.querySelector('[data-main]'); if (m) m.src = b.dataset.img;
      Array.prototype.forEach.call(b.parentNode.children, function (c) { c.classList.toggle('is-on', c === b); });
      return;
    }
    if (b.dataset.edit) return go('quiz', A, b.dataset.edit);
    switch (b.dataset.act) {
      case 'back': var st = E.steps(A); idx = Math.max(0, idx - 1);
        while (idx > 0 && (st[idx] === 'tipo' || st[idx] === 'tam' || st[idx] === 'foco') && A[st[idx]] === 'igual' && optionsFor(st[idx]).filter(function (o) { return o[0] !== 'igual'; }).length <= 1) idx--;
        return renderQuiz();
      case 'next': idx++; return renderQuiz();
      case 'more': return moreCards();
      case 'restart': return go('quiz', A.col ? { det: [], col: A.col } : { det: [] });
      case 'allcats': return go('quiz', A.quien ? { det: [], quien: A.quien } : { det: [] }, A.quien ? 'uso' : '');
      case 'share':
        var url = location.href, sp = b.querySelector('span');
        (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () { sp.textContent = T.copied; }, function () { window.prompt('', url); });
        return;
    }
  });

  function start() {
    var st = decode(location.search.slice(1));
    A = st.a; editing = !!st.paso;
    if (root.getAttribute('data-view') === 'results') {
      if (!A.quien || !A.uso) return go('quiz', { det: [] });
      return renderResults();
    }
    if (!st.paso) A = E.applyCol({ det: [], col: st.a.col });
    var steps = E.steps(A); idx = st.paso ? Math.max(0, steps.indexOf(st.paso)) : 0;
    renderQuiz();
  }

  // ---------------------------------------------------------------- datos
  function getAll(base) {
    var sep = base.indexOf('?') >= 0 ? '&' : '?';
    function page(n) { return fetch(base + sep + 'page=' + n, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
    return page(1).then(function (first) {
      var more = []; for (var n = 2; n <= first.pages; n++) more.push(page(n));
      return Promise.all(more).then(function (rest) { return rest.reduce(function (acc, x) { return acc.concat(x.items); }, first.items); });
    });
  }
  root.innerHTML = '<div class="kf-state"><div class="kf-wrap"><span class="kf-spin" aria-hidden="true"></span>' + T.loading + '</div></div>';
  var jobs = [getAll(CFG.dataUrl)];
  if (LANG !== 'es' && CFG.dataUrlLocal && CFG.dataUrlLocal !== CFG.dataUrl) jobs.push(getAll(CFG.dataUrlLocal).catch(function () { return []; }));
  Promise.all(jobs).then(function (res) {
    DATA = E.prepAll(res[0]);
    if (res[1] && res[1].length) {             // textos en el idioma del visitante (traducciones de la tienda)
      var byId = {}; res[1].forEach(function (x) { byId[x.id] = x; });
      DATA.forEach(function (p) {
        var x = byId[p.id]; if (!x) return; var s = x.s || {};
        p.L = { t: x.t, url: x.u, aceroTxt: s.acero, mangoTxt: s.mango, punta: s.punta_de_la_hoja, afilado: s.hoja, acabado: s.acabado_de_la_hoja,
          cierre: s.sistema_de_cierre, estructura: s.estructura, virola: s.cruceta_virola, anclaje: s.anclaje_del_mango, fundaTxt: s.material_funda,
          extras: (s.extras || []).length === p.extras.length ? s.extras : null };
      });
    }
    start();
  }).catch(function () {
    root.innerHTML = '<div class="kf-state"><div class="kf-wrap">' + T.error + '</div></div>';
  });
})();
